import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Typography } from 'antd';
import { MailOutlined, VideoCameraOutlined, EnvironmentOutlined } from '@ant-design/icons';
import api from '../../api';
import { DEFAULT_GUTTER } from '../../constants';
import './style.css';
import {useTranslations} from "../../lang";

const { Title, Text } = Typography;

export default function Footer() {
    const [blogs, setBlogs] = useState([]);
    const {language} = useTranslations()

    useEffect(() => {
        api.getAllBlogs(language)
            .then(data => {
                setBlogs(data.slice(0, 3));
            })
            .catch(error => {
                console.error('Error loading blogs for footer:', error);
            });
    }, [language]);

    return (
        <footer className="oogst-footer">
            <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '3rem 1rem' }}>
                <Row gutter={DEFAULT_GUTTER}>
                    {/* Contact Information */}
                    <Col xs={24} md={12}>
                        <section aria-labelledby="footer-contact-title">
                            <Title id="footer-contact-title" level={2} style={{ color: '#006e2f', marginBottom: '1.5rem', fontSize: '1.25rem' }}>
                                Contact
                            </Title>
                            <address style={{ fontStyle: 'normal' }}>
                                <div style={{ marginBottom: '1rem' }}>
                                    <EnvironmentOutlined style={{ marginRight: '0.5rem', color: '#006e2f' }} aria-hidden="true" />
                                    <Text>Rijksstraatweg 55, 8121ED, Den Nul</Text>
                                </div>
                                <div style={{ marginBottom: '1rem' }}>
                                    <MailOutlined style={{ marginRight: '0.5rem', color: '#006e2f' }} aria-hidden="true" />
                                    <a href="mailto:stef@oogst.app" style={{ color: '#333' }}>
                                        stef@oogst.app
                                    </a>
                                </div>
                                <div>
                                    <VideoCameraOutlined style={{ marginRight: '0.5rem', color: '#006e2f' }} aria-hidden="true" />
                                    <a
                                        href="https://koalendar.com/e/kletsen-met-stef"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: '#333' }}
                                    >
                                        Gesprek inplannen
                                    </a>
                                </div>
                            </address>
                        </section>
                    </Col>

                    {/* Blog Links */}
                    <Col xs={24} md={12}>
                        <nav aria-labelledby="footer-blog-title">
                            <Title id="footer-blog-title" level={2} style={{ color: '#006e2f', marginBottom: '1.5rem', fontSize: '1.25rem' }}>
                                Blog
                            </Title>
                            {blogs.map((blog) => (
                                <div key={blog.id} style={{ marginBottom: '0.75rem' }}>
                                    <Link
                                        to={`/blog/${blog.slug}`}
                                        style={{
                                            color: '#333',
                                            textDecoration: 'none',
                                            transition: 'color 0.3s'
                                        }}
                                        className="footer-blog-link"
                                    >
                                        {blog.title}
                                    </Link>
                                </div>
                            ))}
                        </nav>
                    </Col>
                </Row>

                <div style={{
                    marginTop: '2rem',
                    paddingTop: '2rem',
                    borderTop: '1px solid #e0e0e0',
                    textAlign: 'center'
                }}>
                    <nav aria-label="Footer navigatie" style={{ marginBottom: '1rem' }}>
                        <Link
                            to="/tos"
                            style={{
                                color: '#666',
                                textDecoration: 'none',
                                marginRight: '1.5rem',
                                transition: 'color 0.3s'
                            }}
                            className="footer-blog-link"
                        >
                            {language === 'en' ? 'Terms of Service' : 'Algemene Voorwaarden'}
                        </Link>
                        <Link
                            to="/privacy-policy"
                            style={{
                                color: '#666',
                                textDecoration: 'none',
                                transition: 'color 0.3s'
                            }}
                            className="footer-blog-link"
                        >
                            {language === 'en' ? 'Privacy Policy' : 'Privacybeleid'}
                        </Link>
                    </nav>
                    <Text type="secondary">
                        © {new Date().getFullYear()} Oogst.app - {language === 'en' ? 'All rights reserved' : 'Alle rechten voorbehouden'}
                    </Text>
                    <div style={{ marginTop: '1rem' }}>
                        <a
                            href="https://asyncforge.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer-asyncforge-link"
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                color: '#666',
                                textDecoration: 'none',
                                transition: 'color 0.3s'
                            }}
                        >
                            <Text type="secondary">proudly made by</Text>
                            <img
                                src="/static/img/asyncforge-logo.svg"
                                alt="AsyncForge"
                                style={{ height: '20px', width: '20px' }}
                            />
                            <Text type="secondary" style={{ fontWeight: 600 }}>AsyncForge</Text>
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
